<template>
    <div>
        <v-dialog v-model="abrirDialog" max-width="600px" persistent>
            <v-card>
                <v-btn icon class="close-btn" @click="fecharDialog()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-card-title class="text-h5 font-weight-bold">
                    Limite de Saldo Devedor Excedido
                </v-card-title>
                <v-card-text>
                    <p class="text-body-1" style="font-size: 1.1rem; line-height: 1.6;">
                        Essa operação <strong>ultrapassa o limite de saldo devedor parametrizado para o grupo pontual.</strong>
                        Devido ao risco solicitado prossiga para que essa proposta
                        <strong>passe por uma análise de grandes negócios</strong> pela Área de Crédito.
                    </p>
                    <br>
                    <div class="d-flex align-items-center my-4 info-block">
                        <div class="mr-4" style="width: 45%;">
                            <div style="font-size: 1rem; font-weight: bold;">Saldo devedor atual:</div>
                            <br>
                            <div class="value-dark" style="font-size: 1.3rem; font-weight: bold;">
                                R$ {{ saldoDevedorAtual }}
                            </div>
                        </div>
                        <v-icon mid class="mx-6 align-self-center">mdi-arrow-right</v-icon>
                        <div class="ml-4" style="width: 45%;">
                            <div style="font-size: 1rem; font-weight: bold;">Limite do grupo:</div>
                            <br>
                            <div style="font-size: 1.3rem; font-weight: bold;" class="primary--text">
                                R$ {{ limiteGrupo }}
                            </div>
                        </div>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn id="btn-ok" color="primary" @click="confirmar()">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    props: {
        visivel: {
            type: Boolean,
            required: true
        },
        saldoDevedorAtual: {
            type: String,
            required: true
        },
        limiteGrupo: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            abrirDialog: this.visivel
        }
    },
    watch: {
        visivel(newValue) {
            this.abrirDialog = newValue
        },
        abrirDialog(newValue) {
            if (newValue === false) {
                this.$emit('fechar')
            }
        }
    },
    methods: {
        fecharDialog() {
            this.abrirDialog = false
        },
        confirmar() {
            this.abrirDialog = false
            this.$emit('prosseguir')
        }
    }
}
</script>

<style scoped>
.close-btn {
    position: absolute;
    top: 10px;
    right: 10px;
}

.info-block {
    background-color: #f5f5f5;
    padding: 16px;
    border-radius: 8px;
}

.value-dark {
    color: #333;
}
</style>
